angular.module('rjmNg.directives').directive "signupChannelsMysql", [
  () ->
    restrict: "E"
    templateUrl: "directive.signupChannelsMysql.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      initState: "<"
    controller: [
      "$location"
      "$routeParams"
      "$rootScope"
      "appRoute"
      "Clients"
      (
        $location
        $routeParams
        $rootScope
        appRoute
        Clients
      ) ->

        view = @

        _clientId = null
        _skipModal = '#skip-modal'

        view.prefUrl = appRoute('/magento/connect/mysql/preferences')

        _hideSkipModal = () ->
          $(_skipModal).modal('hide')

        _navigateToNextStep = () ->
          $location.path(appRoute('/magento/connect/googleAnalytics'))

        view.hideSkipModal = () ->
          _hideSkipModal()

        view.gotoConnection = () ->
          $location.path(appRoute('/magento/connect/mysql'))
        
        view.gotoGA = () ->
          _navigateToNextStep()
        
        view.gotoPref = () ->
          $location.path(appRoute('/magento/connect/mysql/preferences'))

        view.showSkip = () ->
          $(_skipModal).modal()

        view.skipConnection = () ->
          _hideSkipModal()
          _navigateToNextStep()

        view.$onInit = () ->
          _clientId = $routeParams.clientId

          if(view.initState)
            view.viewState = view.initState
          else
            Clients.get(_clientId).then((success)->
              { properties: { has_guest_checkout, magento_version } } = success
              hasPreferences = has_guest_checkout && magento_version
              if(hasPreferences)
                view.viewState = 3
              else
                view.viewState = 1
            (error)->
                view.viewState = 4
            )

        view.$onDestroy = () ->
          _modalCloseListener()

        _modalCloseListener = $rootScope.$on('$locationChangeStart', (next, current) -> 
          _hideSkipModal()
        )

        return view
    ]
]
